<template>
    <div class="templateBox">
        <div style="display: flex">
            <el-form ref="listArgument" :model="listArgument">
                <el-form-item>
                    <el-input v-model="listArgument.keywords" placeholder="请输入搜索内容"></el-input>
                </el-form-item>
            </el-form>
            <div class="searchBox">
                <el-button type="primary" @click="searchBtn">搜索</el-button>
                <el-button @click="clearBtn">清空</el-button>
            </div>
        </div>
        <avue-crud :data="data" :option="option" :page.sync='page'
                   @current-change='changePage' @size-change="sizeChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="previewBtn(scope.row)">预览模板</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="downloadBtn(scope.row)">下载模板</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="deleteBtn(scope.row)">删除模板</el-dropdown-item>
            </template>
            <!--            自定义菜单-->
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" type="primary" @click="addBtn">新增模板</el-button>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { deleteTemplate, gettemplateList } from '../../api/templatePage';

    export default {
        name: 'templatePage',
        data() {
            return {
                listArgument: {
                    keywords: '',
                    limit: 10,
                    page: 1
                },
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10  //每页条数
                },
                data: [],
                option: {
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    column: [
                        {
                            label: '序号',
                            prop: 'xuhao'
                        }, {
                            label: '模板名称',
                            prop: 'name'
                        }, {
                            label: '更新时间',
                            prop: 'update_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //新增模板
            addBtn() {
                this.$router.push({
                    path: '/addTemplate'
                });
            },
            //搜索
            searchBtn() {
                this.listArgument.page = 1;
                this.getList();
            },
            //清空
            clearBtn() {
                this.listArgument.keywords = '';
                this.listArgument.page = 1;
                this.listArgument.limit = 10;
                this.getList();
            },
            //分页
            changePage(num) {
                this.listArgument.page = num;
                gettemplateList(this.listArgument).then(res => {
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                });
                sessionStorage.setItem('templatePage', num);
            },
            //切换页面条数
            sizeChange(val) {
                this.listArgument.limit = val;
                if (sessionStorage.getItem('templatePage')) {
                    sessionStorage.removeItem('templatePage');
                    this.listArgument.page = 1;
                }
                this.getList();
            },
            //获取列表数据
            getList() {
                let num = Number(sessionStorage.getItem('templatePage'));

                gettemplateList(this.listArgument).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        // this.page.currentPage = 1
                        this.page.currentPage = (this.page.currentPage && num !== 0) ? num : 1;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            //预览
            previewBtn(row) {
                this.$router.push({
                    path: '/preview',
                    query: {
                        id: row.id
                    }
                });
            },
            //下载模板
            downloadBtn(row) {
                window.open(process.env.VUE_APP_BASE_API + `/api/case_tpl_download?id=${row.id}`, '_blank');
            },
            //删除模板
            deleteBtn(row) {
                this.$confirm('请确认是否要删除该模板 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteTemplate({ id: row.id }).then(res => {
                        if (res.code == 200) {
                            this.$message.success(res.msg);
                            this.$nextTick(() => {
                                if (res.code == 200) {
                                    this.getList();
                                }
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    });
                }).catch(() => {

                });
            }
        },
        created() {
            let num = Number(sessionStorage.getItem('templatePage'));
            if (num == 0) {
                this.getList();
            } else {
                this.listArgument.page = num;
                gettemplateList(this.listArgument).then(res => {
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = num;
                });
            }
        }
    };
</script>

<style scoped lang="less">

    .templateBox {
        background-color: #ffffff;
        padding: 20px;
        border-radius: 5px;
    }

    .searchBox {
        margin-left: 10px;
    }

    .transfer-buttons {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .custom {
        background-color: #409EFF;
        color: #ffffff;
    }

    .searchBox {
        button {
            margin-left: 10px;
        }
    }

    .pull-down {
        padding: 10px 30px;
    }


</style>
